import { RouterModule, Routes } from '@angular/router';
import { AuthGuard, OtpGuard, SessionGuard } from './shared/guard/auth.guard';
import { NgModule } from '@angular/core';
import { PageNotFoundComponent } from './layout/component/page-not-found/page-not-found.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import("./layout/layout.module").then(m => m.LayoutModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'login',
    loadChildren: () => import("./auth/login/login.module").then(m => m.LoginModule),
    canActivate: [SessionGuard],
  },
  {
    path: 'forgot-password',
    loadChildren: () => import("./auth/forgot-password/forgot-password.module").then(m => m.ForgotPasswordModule)
  },
  {
    path: 'reset-password/:encEmail/:encEmailToken',
    loadChildren: () => import("./auth/reset-password/reset-password.module").then(m => m.ResetPasswordModule),
    data: { title: 'Reset Password' }
  },
  {
    path: 'set-password/:encEmail/:encEmailToken',
    loadChildren: () => import("./auth/reset-password/reset-password.module").then(m => m.ResetPasswordModule),
    data: { title: 'Set Password' }
  },
  {
    path: 'otp',
    loadChildren: () => import('./auth/otp-verify/otp-verify/otp-verify-routing.module').then(m => m.OtpVerifyRoutingModule),
    canActivate: [OtpGuard],
  },
  { path: '**', component: PageNotFoundComponent, canActivate: [AuthGuard] },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
